import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/admin/journal` - une REDIRECTION vers `/admin/sessions`, et rien d'autre
 * (refonte modulaire §15).
 *
 * « Le renommage emporte l'adresse » (grill du 2026-09-14) : l'écran s'appelle
 * Sessions, il vit en `/admin/sessions`, et ce fichier ne garde que ce qui
 * justifiait de ne pas le supprimer - `/admin/journal?session=` a circulé dans
 * des fils d'équipe, et un lien collé doit continuer d'arriver quelque part.
 *
 * ## Le `?session=` VOYAGE, et c'est tout le sujet
 *
 * Une redirection qui laisserait tomber le paramètre vaudrait moins qu'une
 * erreur 404 : elle ouvrirait la bonne liste sur la mauvaise ligne, sans rien
 * dire. Le reste de l'ancienne adresse n'est pas repris - `experience`,
 * `status` et `link` étaient les trois filtres de l'écran minimal, et personne
 * ne colle une liste filtrée d'un écran qui a été remplacé. Le `?session=`, si.
 *
 * `validateSearch` NE LÈVE JAMAIS : il tourne sur ce que quelqu'un a tapé, et
 * une exception ici serait un écran blanc pour une faute de frappe.
 */

type JournalSearch = {
  session?: string | undefined;
};

function readSearch(search: Record<string, unknown>): JournalSearch {
  const raw = typeof search.session === 'string' ? search.session.trim() : '';
  return raw === '' ? {} : { session: raw };
}

export const Route = createFileRoute('/admin/journal')({
  validateSearch: readSearch,
  /*
    Dans `beforeLoad` et pas dans un composant : la redirection se résout AVANT
    que quoi que ce soit ne soit peint, porte d'opérateur comprise. C'est ce qui
    fait que la porte nomme « Ouvrir les sessions » sur cette adresse-ci, le
    régime que `reglages.index.tsx` a posé.
  */
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/admin/sessions',
      search: search.session === undefined ? {} : { session: search.session },
    });
  },
});
